import { createContext, useContext } from 'react';
import type { CanvasItem } from './collect-items';
import type { CanvasView } from './canvas-storage';

/**
 * FRONT-2594 — what the chat window shares with the tool cards inside it.
 * `null` outside the provider (other surfaces, flag off), which is how a card
 * knows to render byte-identically to today.
 */
export interface CanvasContextValue {
  items: CanvasItem[];
  open: boolean;
  activeKey: string | null;
  view: CanvasView;
  /** Activate an item and open the panel (narrow screens: also switch to the Canvas view). */
  openItem: (key: string) => void;
}

export const CanvasContext = createContext<CanvasContextValue | null>(null);

export function useCanvas(): CanvasContextValue | null {
  return useContext(CanvasContext);
}

/** True when this item is the one on show: panel open AND it is the active item. */
export function isShowing(ctx: CanvasContextValue | null, key: string): boolean {
  return !!ctx && ctx.open && ctx.activeKey === key;
}
